// extracted by css-extract-rspack-plugin
export default {"header":"R4e2SkLlAf6ZCOeV","tabs":"SaRb83yrM_cAkDCw","content":"pb2JMeWNKLUhcIu3","content--inset-s":"xJm8hhYqtAvNzoVa"};